module.exports = __webpack_public_path__ + "img/time.809df2f6.svg";